module.exports = __webpack_public_path__ + "img/HenningGutzmann_140x140_rund.44ebb241.jpg";